import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

export function useTheme() {
  const [theme, setTheme] = useState(() => localStorage.getItem("nimocems-theme") || "dark");
  useEffect(() => {
    document.documentElement.classList.toggle("light", theme === "light");
    localStorage.setItem("nimocems-theme", theme);
    window.dispatchEvent(new Event("nimocems-theme"));
  }, [theme]);
  return [theme, setTheme];
}

export function useIsLight() {
  const [light, setLight] = useState(() => localStorage.getItem("nimocems-theme") === "light");
  useEffect(() => {
    const f = () => setLight(document.documentElement.classList.contains("light"));
    window.addEventListener("nimocems-theme", f);
    return () => window.removeEventListener("nimocems-theme", f);
  }, []);
  return light;
}

export function ThemeToggle() {
  const [theme, setTheme] = useTheme();
  const light = theme === "light";
  return (
    <button data-testid="theme-toggle" onClick={() => setTheme(light ? "dark" : "light")} title={light ? "Switch to dark mode" : "Switch to light mode"}
      className="inline-flex items-center gap-1.5 rounded-full border border-white/10 px-2.5 py-0.5 text-slate-300 transition-colors hover:bg-white/10">
      {light ? <Moon className="h-3.5 w-3.5" /> : <Sun className="h-3.5 w-3.5" />}{light ? "Dark" : "Light"}
    </button>
  );
}
